import { createAction } from "redux-starter-kit";
import { OPEN_SEND_NOA } from "../types";

const openSendNOA = () => createAction(OPEN_SEND_NOA)({});

export default openSendNOA;
